import { TOS_LINKS } from "@/constants";
import { Trans } from "@lingui/react/macro";
import { ExternalLinkIcon } from "lucide-react";

export default function Footer() {
  return (
    <p className="text-sm text-muted-foreground">
      <Trans>
        Genom att använda All Ears godkänner du{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href={TOS_LINKS.YOUTUBE}
          className="link inline-flex items-center gap-1"
        >
          YouTubes användarvillkor
          <ExternalLinkIcon className="size-3.5" />
        </a>{" "}
        och{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href={TOS_LINKS.GOOGLE}
          className="link inline-flex items-center gap-1"
        >
          Googles integritetspolicy
          <ExternalLinkIcon className="size-3.5" />
        </a>
        .
      </Trans>
    </p>
  );
}
